import { render, staticRenderFns } from "./ResponsiveNavigation.vue?vue&type=template&id=08a46de4&scoped=true&"
import script from "./ResponsiveNavigation.vue?vue&type=script&lang=js&"
export * from "./ResponsiveNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveNavigation.vue?vue&type=style&index=0&id=08a46de4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a46de4",
  null
  
)

export default component.exports